import { render, staticRenderFns } from "./AnnouncementCard.vue?vue&type=template&id=1a5281fc"
import script from "./AnnouncementCard.vue?vue&type=script&lang=js"
export * from "./AnnouncementCard.vue?vue&type=script&lang=js"
import style0 from "./AnnouncementCard.vue?vue&type=style&index=0&id=1a5281fc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports